import React, { ReactElement } from "react";
import Content from "./Content";
import {
  Accordion as MuiAccordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

export default function Accordion(props: any): ReactElement {
  const { children, title } = props;
  return (
    <MuiAccordion sx={{ mb: "10px" }}>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography>{title}</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Content contentValue={children} />
      </AccordionDetails>
    </MuiAccordion>
  );
}
